import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { cssValue } from "../helpers/styles.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class TextHtml extends VisualSuperHtml {
  handlers = this.extendParentHandlers({
    "text.content": this.setContent,
    "text.maxCharacters": this.setContent,
    "text.singleLine": this.setSingleLine,
    "text.toUpperCase": this.setUpperCase,
    "text.toLowerCase": this.setLowerCase,
    "shadow.x": this.setTextShadow,
    "shadow.y": this.setTextShadow,
    "shadow.blur": this.setTextShadow,
    "shadow.color": this.setTextShadow,
    "text.color": this.textColor,
  });

  setProps(eNode) {
    eNode.element = create(eNode, "span");
    this.setSingleLine(eNode);

    super.setProps(eNode);
  }

  setSingleLine(eNode) {
    eNode.element.style.whiteSpace = eNode.props["text.singleLine"] ? "nowrap" : "pre-wrap";
  }

  setContent(eNode) {
    let content = eNode.props["text.content"] === undefined ? "" : eNode.props["text.content"];

    const maxChars = eNode.props["text.maxCharacters"];
    if (maxChars !== undefined && maxChars !== 0) {
      content = this.#cropContent(content, maxChars);
    }

    eNode.element.innerHTML = content;
  }

  setUpperCase(eNode) {
    if (!eNode.props["text.toUpperCase"]) {
      eNode.element.style.textTransform = "none";
      return;
    }
    eNode.element.style.textTransform = "uppercase";
  }

  setLowerCase(eNode) {
    if (!eNode.props["text.toLowerCase"]) {
      eNode.element.style.textTransform = "none";
      return;
    }
    eNode.element.style.textTransform = "lowercase";
  }

  #cropContent(content, maxChars) {
    if (content.length < maxChars) {
      return content;
    }

    return content.slice(0, Math.max(0, maxChars)) + "...";
  }

  applyLayout(eNode) {
    this.fontSize(eNode);
    this.textLineHeight(eNode);
    this.textLetterSpacing(eNode);
    super.applyLayout(eNode);
  }

  textDecoration(eNode) {
    eNode.element.style.textDecoration = eNode.props["text.decoration"];
  }

  textColor(eNode) {
    eNode.element.style.color = eNode.props["text.color"];
  }

  textAlign(eNode) {
    eNode.element.style.textAlign = eNode.props["text.align"];
  }

  fontWeight(eNode) {
    eNode.element.style.fontWeight = eNode.props["font.weight"];
  }

  fontStyle(eNode) {
    eNode.element.style.fontStyle = eNode.props["font.style"];
  }

  fontSize(eNode) {
    eNode.element.style.fontSize = cssValue(eNode.props["font.size"]);
  }

  fontFamily(eNode) {
    eNode.element.style.fontFamily = eNode.props["font.family"];
  }

  textUserSelect(eNode) {
    eNode.element.style.userSelect = eNode.props["text.userSelect"];
  }

  textLetterSpacing(eNode) {
    eNode.element.style.letterSpacing = cssValue(eNode.props["text.letterSpacing"]);
  }

  textLineHeight(eNode) {
    eNode.element.style.lineHeight = cssValue(eNode.props["text.lineHeight"]);
  }

  fontVariation(eNode) {
    eNode.element.style.fontVariationSettings = eNode.props["font.variation"];
  }

  fontOpticalSizing(eNode) {
    eNode.element.style.fontOpticalSizing = eNode.props["font.opticalSizing"];
  }

  fontStretch(eNode) {
    eNode.element.style.fontStretch = eNode.props["font.stretch"];
  }

  setTextShadow(eNode) {
    const shadowOffsetX = eNode.props["shadow.x"];
    const shadowOffsetY = eNode.props["shadow.y"];
    const shadowBlur = eNode.props["shadow.blur"];
    const shadowColor = eNode.props["shadow.color"];

    if (shadowColor === undefined) {
      eNode.element.style.textShadow = "none";
    } else {
      const offsetX = shadowOffsetX !== undefined ? shadowOffsetX : 0;
      const offsetY = shadowOffsetY !== undefined ? shadowOffsetY : 0;
      const blur = shadowBlur !== undefined ? shadowBlur : 0;
      eNode.element.style.textShadow = `${offsetX}px ${offsetY}px ${blur}px ${shadowColor}`;
    }
  }
}

const textHtml = new TextHtml("visual:text");
visualEntities.set("visual:text", textHtml);
export { TextHtml, textHtml };
